import parse from 'html-react-parser';
import { OpenInNew } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Grid, Box, Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ButtonBase,
  useMediaQuery,
  // Button,
} from '@mui/material';
import { Link } from 'react-router-dom';
import i18n from '../common/i18n';
import '../../assests/css/branches.css';
import wppIcon from '../../assests/images/icon-wpp-color.svg';
import {
  getEnv,
  SEND_WPP,
} from '../../api/env';
// import logoCredicuotas from '../../images/logo_credicuotas_desktop.svg';

import logoCredicuotasMobile from '../../images/logo_credicuotas_mobile.svg';
import landingBranch from '../../assests/images/branches/landing-branches-to-digital.svg';
import branchesAnouncement from '../../assests/images/branches/branches-to-digital.svg';
import branchesHelp1 from '../../assests/images/branches/help-option-branches-1.svg';
import branchesHelp2 from '../../assests/images/branches/help-option-branches-2.svg';
import branchesHelp3 from '../../assests/images/branches/help-option-branches-3.svg';
import tic from '../../assests/images/home/tic.png';
import { fillMessageWith, isMobileOperatingSystem, redirectToStore } from '../../utils/functionUtils';
/* eslint "arrow-body-style": "off" */
const Branches = () => {
  const isMobile = isMobileOperatingSystem();
  const SEND_WPP_BRANCH_CLOSED = `${getEnv(SEND_WPP)}?phone=5491164575091&text=%C2%A1Hola!%20`
  + 'Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20cierre'
  + '%20de%20la%20sucursal%20y%20c%C3%B3mo%20gestionar%20mis%20pr%C3%A9stamos%20online.';
  const sendWpp = () => {
    window.open(SEND_WPP_BRANCH_CLOSED, '_blank');
  };
  const isWeb = useMediaQuery('(min-width:1222px)');
  return (
    <>
      <header style={{ backgroundColor: 'white', height: (isMobile ? '50px' : '58px') }}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item lg={8} className="gridLogoHeader">
            <Link
              to={{ pathname: '/' }}
              style={{ textDecoration: 'none' }}
            >
              <img
                src={logoCredicuotasMobile}
                alt={i18n.credicuotas}
                className="logoHeader"
              />
            </Link>
          </Grid>
          <Grid item className="gridLogoHeader headerBtns">
            <Grid container gap={2}>
              {!isMobile && (
              <Grid item>
                <ButtonBase
                  className="contactButtonHeader"
                  onClick={sendWpp}
                >
                  <Typography className="contactButtonText">Contactarnos</Typography>
                  <img src={wppIcon} alt="WhatsApp" className="contactButtonIcon" />
                </ButtonBase>
              </Grid>
              )}
              {isMobile && (
              <Grid item>
                <ButtonBase variant="contained" className="downloadBtn" onClick={redirectToStore}>
                  <div className="downloadBtnText">{i18n.branchesDownloadApp}</div>
                  <OpenInNew className="downloadBtnIcon" />
                </ButtonBase>
              </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </header>
      <Box className="boxBannerBranch">
        <Grid container className="flexStartVertical">
          <Grid item xs={12} lg={isWeb ? 7 : 12} className="bannerHomeBranch">
            <Box className="boxTitleBranch">
              <Typography fontWeight={800} className="lettersWhiteOnly branchTitle">
                {i18n.branchesTitle}
              </Typography>
              <Box mt="12px" className="boxSubtitleHome widthBoxTypography">
                <Typography variant="h4" className="lettersWhiteOnly branchSubitle">
                  {i18n.branchesSubtitle}
                </Typography>
              </Box>
            </Box>
            <Box mt="52px">
              <ButtonBase
                className="contactButton"
                onClick={sendWpp}
              >
                <Typography className="contactButtonText">Contactarnos</Typography>
                <img src={wppIcon} alt="WhatsApp" className="contactButtonIcon" />
              </ButtonBase>
            </Box>
          </Grid>
          {isWeb && (
          <Grid item md={5} lg={5} xl={4} className="landingBranch">
            <img src={landingBranch} alt="landingBranch" className="landingBranchImg" />
          </Grid>
          )}
        </Grid>
      </Box>
      <Box className="boxAnouncement">
        <Grid container className="flexStartVertical">
          <Grid item lg={12}>
            <Typography className="titleSection">
              {parse(isMobile ? i18n.branchesAnouncementMobile : i18n.branchesAnouncement)}
            </Typography>
          </Grid>
          <Grid item marginY="32px" lg={12}>
            <img src={branchesAnouncement} alt="branchesAnouncement" className="branchesAnouncementImg" />
          </Grid>
          <Grid item lg={12}>
            <Typography className="subtitleSection">
              {parse(isMobile ? i18n.branchesAnouncementSubtitleMobile : i18n.branchesAnouncementSubtitle)}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box className="boxHelp">
        <Grid container className="flexStartVertical">
          <Grid item lg={12}>
            <Typography className="titleSection">{parse(i18n.branchesHelpTitle)}</Typography>
          </Grid>
          <Grid item lg={12}>
            <Typography className="subtitleSectionHelp">{parse(i18n.branchesHelpSubtitle)}</Typography>
          </Grid>
          <Box className="branchesHelp" direction={isWeb ? 'row' : 'column'}>
            <Box className="helpCard">
              <Box className="helpImage">
                <img
                  src={branchesHelp1}
                  alt="help1"
                />
              </Box>
              <Typography className="branchesHelpText">
                {parse(i18n.branchesHelp1)}
              </Typography>
            </Box>

            <Box className="helpCard">
              <Box className="helpImage">
                <img
                  src={branchesHelp2}
                  alt="help2"
                />
              </Box>
              <Typography className="branchesHelpText">
                {parse(i18n.branchesHelp2)}
              </Typography>
            </Box>

            <Box className="helpCard">
              <Box className="helpImage">
                <img
                  src={branchesHelp3}
                  alt="help3"
                />
              </Box>
              <Typography className="branchesHelpText">
                {parse(i18n.branchesHelp3)}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Box>
      {/* Lo más importante */}
      <Box className="boxWhyUsBranch" mt={8}>
        <Typography fontWeight={800} className="lettersWhiteOnly paddingTitle branchWhyUsTitle">
          {i18n.branchesImportantTitle}
        </Typography>
        <Grid container>
          <Grid item xs={1} md={3.2} />
          <Grid item xs={10} md={6}>
            <Box className="whyBoxBranch">
              <img src={tic} alt="tic" className="imgTick" />
              <Box className="whyBoxInside textLeft">
                <Typography fontWeight={400} className="lettersWhiteOnly whyBranchTypo">
                  {i18n.branchesImportant1}
                </Typography>
              </Box>
            </Box>
            <Box className="whyBoxBranch">
              <img src={tic} alt="tic" className="imgTick" />
              <Box className="whyBoxInside textLeft">
                <Typography className="lettersWhiteOnly whyBranchTypo">
                  {i18n.branchesImportant2}
                </Typography>
              </Box>
            </Box>
            <Box className="whyBoxBranch">
              <img src={tic} alt="tic" className="imgTick" />
              <Box className="whyBoxInside textLeft">
                <Typography className="lettersWhiteOnly whyBranchTypo">
                  {i18n.branchesImportant3}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={1} md={2} />
        </Grid>
      </Box>
      {/* preguntas frecuentes */}
      <Typography variant="h3" fontWeight={700} className="lettersGrey" mt={5}>{i18n.faq}</Typography>
      <Grid container mt={3} mb={1}>
        <Grid item xs={1} />
        <Grid item xs={10}>
          <Accordion className="marginBottomQuestions">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h5">{i18n.branchesFAQ1}</Typography>
            </AccordionSummary>
            <AccordionDetails className="textLeft">
              <Typography component="p" fontSize={18}>
                {i18n.branchesFAQ1Answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="marginBottomQuestions">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h5">{i18n.branchesFAQ2}</Typography>
            </AccordionSummary>
            <AccordionDetails className="textLeft">
              <Typography component="p" fontSize={18}>
                {parse(i18n.branchesFAQ2Answer)}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className="marginBottomLastQuestion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h5">{i18n.branchesFAQ3}</Typography>
            </AccordionSummary>
            <AccordionDetails className="textLeft paddingBottomLastQuestion">
              <Typography component="p" fontSize={18}>
                {i18n.branchesFAQ3Answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
      >
        <Grid item mb={5}>
          <Typography className="branchWppMessage">
            {parse(fillMessageWith(i18n.branchWppMessage, SEND_WPP_BRANCH_CLOSED))}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Branches;
